import { HELPER } from '../../utils'

function linkHandler(bool, selectedUrl) {
	HELPER.REDIRECT_TO_PATH(selectedUrl)
	return <></>
}

export default linkHandler
